module.exports = __webpack_public_path__ + "nucleo-icons.6836b93bf1af0b571928.woff";


//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/src/assets/fonts/nucleo-icons.woff
// module id = ../../../../../src/assets/fonts/nucleo-icons.woff
// module chunks = 3